import React from "react";
import { useRef } from "react";
import { useSpring, animated } from "react-spring";
import { useGesture } from "react-use-gesture";
import "./style.css";

function FloatingCard({ container, card, content }) {
  const calcX = (y, ly) => -(y - ly - window.innerHeight / 2) / 120;
  const calcY = (x, lx) => (x - lx - window.innerWidth / 2) / 120;
  const domTarget = useRef(null);
  const [{ x, y, rotateX, rotateY, rotateZ }, api] = useSpring(() => ({
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: 0,
    y: 0,
    config: { mass: 5, tension: 350, friction: 40 },
  }));
  useGesture(
    {
      onMove: ({ xy: [px, py], dragging }) =>
        !dragging &&
        api({
          rotateX: calcX(py, y.get()),
          rotateY: calcY(px, x.get()),
        }),
    },
    { domTarget }
  );
  return (
    <div className={`${container} floating-card-container`} data-aos="zoom-in">
      <animated.div
        ref={domTarget}
        className={`${card} floating-card-card`}
        style={{
          transform: "perspective(600px)",
          x,
          y,
          rotateX,
          rotateY,
          rotateZ,
        }}
      >
        {content}
      </animated.div>
    </div>
  );
}

export default FloatingCard;
